enum LoanPayoutFigureAccruedInterestModeEnum {
    Auto = 'AUTO',
    Off = 'OFF',
}

export default LoanPayoutFigureAccruedInterestModeEnum;